import BaseComponent from '@/components/base';

export default class ChevronButton extends BaseComponent {
  static get observedAttributes() {
    return ['open', 'hide'];
  }

  onOpen = () => {};

  handleClick = () => {};

  chevronDown = `
     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="34" viewBox="0 0 10 24" fill="none">
        <g clip-path="url(#clip0_6689_9017)">
            <path d="M0 5.7684L0.768397 5L5 9.28571L9.2316 5.04329L10 5.7684L5 10.8225L0 5.7684Z" fill="black" fill-opacity="0.8"/>
        </g>
        <defs>
            <clipPath id="clip0_6689_9017">
                <rect width="24" height="10" fill="white" transform="matrix(0 1 -1 0 10 0)"/>
            </clipPath>
        </defs>
    </svg>
  `;
  chevronUp = `
     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="34" viewBox="0 0 10 24" fill="none">
        <g clip-path="url(#clip0_6689_9070)">
            <path d="M10 10.0541L9.2316 10.8225L5 6.5368L0.768398 10.7792L0 10.0541L5 5L10 10.0541Z" fill="black" fill-opacity="0.8"/>
        </g>
        <defs>
            <clipPath id="clip0_6689_9070">
                <rect width="24" height="10" fill="white" transform="matrix(0 1 -1 0 10 0)"/>
            </clipPath>
        </defs>
     </svg>
  `;

  style = `
  <style>
  .chevron {

    display: inline-block;
    transform-origin: center;
    transition: transform 0.5s ease;
  }

  </style>
  `;
  render() {
    return `
    ${this.style}
    ${!this.hide ? (this.isOpen ? this.chevronUp : this.chevronDown) : ''}
    `;
  }

  toggleArrow = () => {
    this.isOpen = !this.isOpen;
  };

  onConnect() {
    const onClickHandler = (event) => {
      this.handleClick && this.handleClick();
    };
    this.addEventListener('click', onClickHandler);
  }

  get isOpen() {
    return this.getAttribute('open') === 'true';
  }

  set isOpen(value) {
    this.setAttribute('open', value.toString());
  }

  get id() {
    return this.getAttribute('id');
  }

  get hide() {
    return (
      this.getAttribute('hide') === 'true' || this.getAttribute('hide') === ''
    );
  }

  set hide(value) {
    this.setAttribute('hide', value.toString());
  }
}
